/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheUserAvatar.vue?vue&type=template&id=3e810e2c&scoped=true"
import script from "./TheUserAvatar.ts?vue&type=script&lang=ts&external"
export * from "./TheUserAvatar.ts?vue&type=script&lang=ts&external"
import style0 from "./TheUserAvatar.vue?vue&type=style&index=0&id=3e810e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e810e2c",
  null
  
)

export default component.exports